import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['rankingButton', 'insuranceFeeButton', 'tbody']

  static values = {
    inChoiceProcess: { type: Boolean, default: true },
    serialNumberRanking: { type: Array, default: [] },
    serialNumberInsuranceFee: { type: Array, default: [] },
  }

  connect() {
    this.createSerialNumberValue()
  }

  createSerialNumberValue() {
    const rankingList = []
    const insuranceFeeList = []

    this.tbodyTargets.forEach((tbody) => {
      tbody
        .querySelectorAll('#table_scroll_area tr:first-child > td')
        .forEach((td) => {
          rankingList.push(td.getAttribute(`data-ranking`))
          insuranceFeeList.push(td.getAttribute(`data-insurance-fee`))
        })
    })

    this.serialNumberRankingValue = rankingList
      .map((v) => Number(v))
      .sort((x, y) => x - y)
    this.serialNumberInsuranceFeeValue = insuranceFeeList
      .filter((value) => value !== '---')
      .map((v) => Number(v))
      .sort((x, y) => x - y)
  }

  reorder(event) {
    if (event.currentTarget.classList.contains('active')) return

    const type = event.params.orderType
    const orderList =
      type === 'insurance-fee'
        ? this.serialNumberInsuranceFeeValue
        : this.serialNumberRankingValue

    this.tbodyTargets.forEach((tbody) => {
      const trs = [...tbody.querySelectorAll('tr')].filter(
        (tr) => tr.children.length > 2
      )
      trs.forEach((tr) => {
        orderList.forEach((value, idx) => {
          const targetTd = tr.querySelector(
            `td:not(.sorting)[data-${type}="${value}"]`
          )
          const tds = tr.querySelectorAll('td')
          targetTd.classList.add('sorting')
          tr.insertBefore(targetTd, tds[idx])
        })
      })

      tbody
        .querySelectorAll('td.sorting')
        .forEach((td) => td.classList.remove('sorting'))
    })

    this.switchOrderButton()
  }

  switchOrderButton() {
    this.rankingButtonTarget.classList.toggle('active')
    this.insuranceFeeButtonTarget.classList.toggle('active')
  }

  hasChoiceableItems() {
    this.tbodyTarget.forEach((tbody) => {
      const unCheckedItems = tbody.querySelectorAll('tr:not(.checked)')

      if (unCheckedItems.length <= 0) return true

      const processedItems = tbody.querySelectorAll(
        'tr:not(.checked):not(.hidden)'
      )

      return processedItems.length > 0
    })
  }
}
